export const actionTypes = {
  REQUEST_START: 'PROPERTY_OBJECTS.OBJECTS.REQUEST_START',
  FILTERED_REQUEST_START: 'PROPERTY_OBJECTS.OBJECTS.FILTERED_REQUEST_START',
  REQUEST_START_SKIP_LOADING: 'PROPERTY_OBJECTS.OBJECTS.REQUEST_START.SKIP_LOADING',
  REQUEST_SUCCESS: 'PROPERTY_OBJECTS.OBJECTS.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'PROPERTY_OBJECTS.OBJECTS.REQUEST_FAILURE',
  UPDATE_TITLE: 'PROPERTY_OBJECTS.OBJECTS.UPDATE_TITLE',
  CLEAR_CHANGES: 'PROPERTY_OBJECTS.OBJECTS.CLEAR_CHANGES',
};
//Добавить новый action FILTERED_REQUEST_START

export function startFilteredRequest() {
  return {
    type: actionTypes.FILTERED_REQUEST_START,
  };
}

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function startRequestSkipLoading() {
  return {
    type: actionTypes.REQUEST_START_SKIP_LOADING,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}

export function updateTitle(data) {
  return {
    type: actionTypes.UPDATE_TITLE,
    payload: data,
  };
}

export function clearChanges(id) {
  return {
    type: actionTypes.CLEAR_CHANGES,
    payload: id,
  };
}
